import { BASE_URL, BASE_URL_DEV } from "../_constants/urlConstants";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

export const ChipCatalogueService = {
  getChipCatalogue,
  getOneChipCatalogue,
};

function getChipCatalogue() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/chip/catalogue-chip`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getOneChipCatalogue(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/chip/catalogue-chip/find`, {
      params: {
        id
      }
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
